module.exports = __webpack_public_path__ + "img/video611.681b42fb.jpg";